import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

import './Navbar.css';
import LanguageList from './LanguageList';
import OfficeDetiles from './OfficeDetiles';
import OfficesList from './OfficesList';
import MainMenu from './MainMenu';

const Navbar = () => {
  const [office, setOffice] = useState({});

  return (
    <nav className="navbar">
      <div className="office-bar d-none d-lg-flex">
        <div className="container">
          <div className="dropdown language">
            <LanguageList />
          </div>

          <div className="office-details">
            <OfficeDetiles office={office} />
            <div className="dropdown office">
              <OfficesList setOffice={setOffice} />
            </div>
          </div>
        </div>
      </div>
      <div className="mainmenu-bar">
        <div className="container">
          <div className="logo pe-3">
            <NavLink to="/">
              <img src="./images/natek_logo.png" alt="Natek Logo" className="d-none d-xl-inline" />
              <img src="./images/natek_logo_small.png" alt="Natek Logo" className="d-xl-none" style={{ maxHeight: '25px' }} />
            </NavLink>
          </div>
          <MainMenu />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
